<template>
  <div class="combo-meal">
    <combo-meal-modal v-model="showComboMealModal" @success="handleSuccess" />
    <!-- 结算弹窗 -->
    <el-dialog :visible.sync="dialogVisible" width="70%" custom-class="combo-meal-dialog">
      <div v-loading="loading" element-loading-text="页面加载中...">
        <iframe :src="orderUrl" frameborder="0" style="width: 100%; height: 80vh" @load="handleIframeLoad"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ComboMealModal from './modules/modal.vue';
export default {
  name: 'ComboMeal',
  model: {
    prop: 'show',
    event: 'change',
  },
  provide() {
    return {
      chooseId: this.$store.state.physicianVisits.xzConsulting,
      expertId: this.$store.state.users.employees.ExpertId,
      customerId:  this.$store.state.users.CsUser.CustomerId,
      shopId:  this.$store.state.bases.shop.ShopId,
      companyId:  this.$store.state.users.user.Company.CompanyId,
      userId: this.$store.state.users.user.UserId
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    // chooseId: {
    //   type: String,
    //   required: true,
    // },
    // expertId: {
    //   type: String,
    //   required: true,
    // },
    // customerId: {
    //   type: String,
    //   required: true,
    // },
    // companyId: {
    //   type: String,
    //   required: true,
    // },
    // shopId: {
    //   type: String,
    //   required: true,
    // }
  },
  components: {
    ComboMealModal
  },
  data() {
    return {
      loading: true,
      orderUrl: '',
      dialogVisible: false,
    }
  },
  methods: {
    handleIframeLoad() {
      this.loading = false;
    },
    handleClick() {
      this.showComboMealModal = true;
    },
    handleSuccess(url) {
      this.orderUrl = url;
      this.loading = true;
      this.dialogVisible = true;
    }
  },
  computed: {
    showComboMealModal: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  },
}
</script>
